import * as React from 'react';
import { connect } from 'react-redux'

import {
    getStaticText,
} from "../reducers/staticTexts";

import { getTranslations } from "../reducers/translations";

import { toggleQuickBetting } from '../actions/quickBet';
import { isQuickBetsActive } from '../reducers/gui';

import QuickBetPresentation from '../presentations/QuickBet/QuickBetPresentation';

const mapStateToProps = (state:any) => {
  return (
    {
      quickBetsState: isQuickBetsActive(state),
      staticTexts: getStaticText(state),
      translations: getTranslations(state)
    }
  )
};

const mapDispatchToProps = (dispatch:Function) => {
    return ({
        toggleQuickBetting: (id:any) => dispatch(toggleQuickBetting(id))
    });
}
export default connect(mapStateToProps, mapDispatchToProps)(QuickBetPresentation);
